import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../../core/store-actions.interface';
import { Subject } from 'rxjs';
import { CcwLoanDataModel } from '../../../closing-cost-worksheet-15/models/ccw-loan-data-model';

function createInitialState(): CcwLoanDataModel {
  return <CcwLoanDataModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-ccw-loan-store' })
export class CmgCcwLoanStore extends Store<CcwLoanDataModel> implements iStoreActions<CcwLoanDataModel> {
  salesPriceUpdate$ = new Subject<number>();
  private _initValue: CcwLoanDataModel = null;
  constructor() {
    super(createInitialState());
  }

  preInitialize(loanInfo: CcwLoanDataModel): void {
    this.update(loanInfo);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  salesPriceUpdate(value?: number): void {
    this.salesPriceUpdate$.next(value);
  }

  reset(hardReset: boolean = false): void {
    if (hardReset) {
      super.reset(); // clear out store - called when ClosingCostWorksheetComponent is destroyed
    } else {
      this.update(this._initValue); // revert back to initial values returned from GetCCW endpoint - called when Reset is clicked
    }
  }

  get initialValue() {
    return this._initValue;
  }
}
